import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import { useAuthContext } from '../contexts/AuthContext';

interface BackofficeContainerProps {
  heading: string;
  description?: string;
  children: React.ReactNode;
}

/** Page chrome inside persistent BackofficeShell (header + body). */
const BackofficeContainer: React.FC<BackofficeContainerProps> = ({
  heading,
  description,
  children
}) => {
  const { logout } = useAuthContext();
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  return (
    <Box
      className="chatyme-backoffice-page"
      sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
    >
      <Paper
        component="header"
        elevation={1}
        sx={{
          bgcolor: 'white',
          p: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: 3
        }}
      >
        <Box>
          <Typography variant="h5" sx={{ mb: 1, fontWeight: 500 }}>
            {heading}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </Box>
        <Button variant="outlined" color="error" onClick={() => setIsLogoutModalVisible(true)}>
          Logout
        </Button>
      </Paper>

      <Box className="chatyme-content-body" sx={{ flexGrow: 1, p: 4, pb: '100px' }}>
        {children}
      </Box>

      <Dialog
        open={isLogoutModalVisible}
        onClose={() => setIsLogoutModalVisible(false)}
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-description"
      >
        <DialogTitle id="logout-dialog-title">Logout</DialogTitle>
        <DialogContent>
          <DialogContentText id="logout-dialog-description">
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsLogoutModalVisible(false)}>Cancel</Button>
          <Button
            onClick={() => {
              setIsLogoutModalVisible(false);
              logout();
            }}
            color="error"
            variant="outlined"
            autoFocus
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default BackofficeContainer;
